import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { CartProductListItemDto } from './CartProductListItemDto'
/**
* Class CartInfo
*  Информация о корзине
*/
export class CartInfo extends ActiveModel {

/**
  * @property items
  * Список элементов страницы<br>  */
  @ActiveField({
    factory: [CartProductListItemDto, () => undefined]
  })
  items?: Array<CartProductListItemDto>


  /**
  * attributesMeta
  *   */
  @ActiveField(() => undefined)
  attributesMeta?: Record<string, object>


  /**
  * totalCost
  * Итоговая стоимость всех товаров в корзине<br>  */
  @ActiveField()
  totalCost?: number
}
